export default __webpack_public_path__ + "static/media/2.076a216c.svg";